import { Link } from "react-router-dom";
import { colorClasses } from "../constants/color";
import { CircleLoading } from "../icons/CircleLoading";

interface RefProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	href?: string;
	className?: string;
	isLoading?: boolean;
	color?: "red" | "blue" | "green" | "roseWhite" | "purple" | "violet" | "mutedViolet" | "instagram" | "facebook";
	variant?: "underline" | "button";
	secondary?: boolean;
	size?: "sm" | "md" | "lg";
	children: React.ReactNode;
}

export const Ref: React.FC<RefProps> = ({ href = "#", children, className = "", isLoading = false, color = "blue", size = "md", secondary = false, variant = "button", ...props }) => {
	const themeColor = colorClasses[secondary ? "secondary" : "primary"][color] || colorClasses[secondary ? "secondary" : "primary"].default;

	const sizeClasses = {
		sm: "max-md:text-xs text-sm px-4 py-2",
		md: "max-md:text-sm text-md px-5 py-2.5",
		lg: "max-md:text-md text-lg px-6 py-3",
	};

	const commonClasses = `flex justify-center select-none rounded-md shadow-md ${className}
        transition-colors duration-300 ${sizeClasses[size]} ${themeColor} ${variant === "underline" && "!bg-transparent !shadow-none underline"} ${isLoading ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`;

	return (
		<Link
			to={href}
			aria-disabled={isLoading}
			className={commonClasses}
			onClick={(e) => isLoading && e.preventDefault()}
			{...props}
		>
			{isLoading ? <CircleLoading /> : children}
		</Link>
	);
};
